import React from "react";
import { FlatList } from "react-native";
import { useUnistyles } from "react-native-unistyles";
import { View } from "@src/components/View";
import { Text } from "@src/components/Text";
import { ContactItem } from "./ContactItem";
import { EmailContact } from "../types";

type EmailContactListProps = {
  contacts: EmailContact[];
  onDeleteContact: (id: string) => void;
};

export function EmailContactList({ contacts, onDeleteContact }: EmailContactListProps) {
  const { theme } = useUnistyles();

  const handleDeleteContact = (id: string) => {
    if (window.confirm("Are you sure you want to remove this contact?")) {
      onDeleteContact(id);
    }
  };

  if (contacts.length === 0) {
    return (
      <View flex={1} justifyContent="center" alignItems="center" px="8xl">
        <Text textStyle="md/regular" color="textMuted" textAlign="center" mb="md">
          No email contacts added yet
        </Text>
        <Text textStyle="sm/regular" color="textMuted" textAlign="center">
          Tap the + button to add an email contact
        </Text>
      </View>
    );
  }

  return (
    <FlatList
      data={contacts}
      keyExtractor={(item, index) => `${item.id}-${index}`}
      renderItem={({ item, index }) => (
        <ContactItem
          title={item.email}
          subtitle={undefined}
          onDelete={() => handleDeleteContact(item.id)}
          testID={`email-contact-${item.id}`}
          isLastItem={index === contacts.length - 1}
        />
      )}
      contentContainerStyle={{ paddingBottom: theme.spacing["3xl"] }}
    />
  );
}
